import React from 'react';
import { useNavigate } from 'react-router-dom';

const EventDetails: React.FC = () => {
    const navigate = useNavigate();

    const handleGenerateClick = () => {
        navigate('/generator');
    };

    return (
        <div className="landing-page">
            <div className="event-hero">
                <h1 className="event-title">Dubai Meelad Conference (Season 2)</h1>
                <div className="byline">Organized by <strong>Dubai Wafy Alumni Association</strong></div>
                <div className="hero-badges">
                    <span className="badge">Religious & Community Gathering</span>
                    <span className="badge">Meelad Celebration</span>
                </div>
                <p className="event-description">Create your conference profile frame in seconds. Tap “Generate” to start.</p>
                
                <div className="event-details">
                    <div className="event-detail">
                        <span className="detail-label">Date</span>
                        <span className="detail-value">Saturday, September 13, 2025</span>
                    </div>
                    <div className="event-detail">
                        <span className="detail-label">Time</span>
                        <span className="detail-value">6:30 PM</span>
                    </div>
                    <div className="event-detail">
                        <span className="detail-label">Venue</span>
                        <span className="detail-value">Woodlem Park School, Al Nahda‑2, Dubai, UAE</span>
                    </div>
                    <div className="event-detail">
                        <span className="detail-label">Organizer</span>
                        <span className="detail-value">Dubai Wafy Alumni Association</span>
                    </div>
                </div>
            </div>
            
            <button className="generate-btn" onClick={handleGenerateClick}>
                Create Your Conference Profile Picture
            </button>
        </div>
    );
};

export default EventDetails;